import { MAX_LATEST_EFFICE_BATCH_SIZE } from "constants/constants";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectTextEffices } from "slices/efficeTreeSlice";
import {
  reassessScrollSubs,
  startScrollListeners,
  stopScrollListeners,
} from "slices/textSlice";
import TextEfficeItem from "./TextEfficeItem/TextEfficeItem";

const RenderedTextEffices = ({ scrollRef, myId }) => {
  const textEffices = useSelector(selectTextEffices);
  window.efs_debug && window.log("RENDERED RENDERETEXTEFFUCES", 2);

  useEffect(() => {
    startScrollListeners(scrollRef.current);
    return () => stopScrollListeners();
  }, [scrollRef]);

  useEffect(() => {
    if (textEffices.length >= MAX_LATEST_EFFICE_BATCH_SIZE)
      reassessScrollSubs();
  }, [textEffices]);

  let items = [];

  // debugger;
  for (let i = 0; i < textEffices.length; i++) {
    items.push(
      <TextEfficeItem
        key={textEffices[i]}
        id={textEffices[i]}
        myId={myId}
        // prevId={textEffices[i + 1]}
      />
    );
  }

  return items;
};

export default RenderedTextEffices;
